import {EditProduct} from "./EditProduct";
import {Grid} from "@mui/material";
import {grey} from "@mui/material/colors";
import {HardwareTable} from "./HardwareTable";
import {Library} from "./library/Library";
import React, {useRef} from "react";
import {useIsQuote} from "../../quote/QuoteContainer";
import {api} from "../../../../api/API";
import {HwLibraryTypeProvider} from "./library/HwLibraryType";
import {cellInActive} from "../pricing/cellconst";
import {HwEditingContextProvider} from "./HwEditingContextProvider";
import {ProjectPageTitle} from "../ProjectPageTitle";
import {SupplierProvider} from "./SupplierContext";

export function useHwAPI() {
    const isQuote = useIsQuote();
    return isQuote ? api.quoteHardware : api.hardware;
}

export function HardwareGeneric() {
    const scrollRef = useRef<HTMLDivElement|null>(null);

    return (
        <HwLibraryTypeProvider value="hardware">
            <EditProduct mode="hardware">
                <SupplierProvider>
                    <ProjectPageTitle title="Hardware" />
                    <Grid container style={{borderTop: "1px solid " + grey["300"], flex: 1, overflow: "auto"}} direction="row" alignItems="stretch">
                        <Grid item xs ref={scrollRef} style={{overflowY: "auto", background: cellInActive, flex: 1, height: "100%"}}>
                            <HwEditingContextProvider scrollRef={scrollRef}>
                                <HardwareTable key="-" />
                            </HwEditingContextProvider>
                        </Grid>
                        <Grid item style={{width: 400, height: "100%", overflowY: "auto"}}>
                            <div style={{
                                borderLeft: "1px solid " + grey["300"], height: "100%",
                                display: "flex", flexDirection: "column",
                            }}>
                                <Library />
                            </div>
                        </Grid>
                    </Grid>
                </SupplierProvider>
            </EditProduct>
        </HwLibraryTypeProvider>
    )
}